module.exports = {"140109001":"千峰街道","140109002":"下元街道","140109003":"和平街道","140109004":"兴华街道","140109005":"万柏林街道","140109006":"杜儿坪街道","140109007":"白家庄街道","140109008":"南寒街道","140109009":"东社街道","140109010":"化客头街道","140109011":"小井峪街道","140109012":"西铭街道","140109013":"长风西街街道","140109014":"神堂沟街道","140109200":"王封乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140109.json
// module id = 263
// module chunks = 0